const statesToArray = states => Object.keys(states).map(
  state => ({ state, ...states[state] }),
)

export default statesToArray



// WEBPACK FOOTER //
// ./src/components/Visualizations/util/states-to-array.js